import { MentorProfileAdminReviewScreen } from "@/components/users/mentor-profile-admin-review-screen";
import { requirePermission } from "@/lib/casl/route-guards";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/users/mentor-profile-reviews/$reviewId",
)({
  component: MentorProfileReviewRoute,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "mentor-profile-reviews");
  },
});

function MentorProfileReviewRoute() {
  const { reviewId } = Route.useParams();
  return <MentorProfileAdminReviewScreen reviewId={reviewId} />;
}
